module.exports = __webpack_public_path__ + "site/img/30.f388bb34.jpg";